export default __webpack_public_path__ + "static/media/tmp_fincar_image04.fbe5bd21.png";